import { formProviderHOC, FormWithControlledNavigation } from '@sravni/cosago-react-library/lib/components';
import type { FormComponentProps } from '@sravni/cosago-react-library/lib/types';
import type { FC } from 'react';

import { useCommonFormBodyHooks } from 'shared/lib/useCommonFormBodyHooks';
import type { TCommonAdditionalFormProps } from 'shared/types';

import type { TLandingFormFields } from 'entities/creditForm';

import { LandingInfoTexts } from 'widgets/AnketaWidget/ui/LandingInfo/LandingInfo.texts';

import { FormFieldsControls, FormFieldsNavigationSequence } from '../LandingInfo.config';

import { FormBody } from './FormBody/FormBody';

type TLandingInfoFormView = TCommonAdditionalFormProps & {
  shouldRestoreAdditionalData: boolean;
};

type Props = FormComponentProps<TLandingFormFields, TLandingInfoFormView>;

const LandingInfoFormView: FC<Props> = (props) => {
  const { onSubmit, submitButtonText, FieldConstructor, isLoading } = props;

  const { controls } = useCommonFormBodyHooks({
    currentControls: FormFieldsNavigationSequence,
    isFormForceOpened: false,
  });

  return (
    <FormWithControlledNavigation
      onSubmit={onSubmit}
      controlElement={FieldConstructor}
      isLoading={isLoading}
      submitButtonText={submitButtonText}
      navigationControls={controls}
      withSubmitButtons={false}
    >
      <FormBody
        formLabels={LandingInfoTexts}
        formFieldsControls={FormFieldsControls}
        isLoading={isLoading}
      />
    </FormWithControlledNavigation>
  );
};

export const LandingInfoViewHoc = formProviderHOC<TLandingFormFields, TLandingInfoFormView>(
  LandingInfoFormView as unknown as FC<Props>,
);
